module.exports = __webpack_public_path__ + "static/media/04B.32998589.png";